import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import _ from 'lodash'
import moment from '../../../lib/moment.js'
import styled from 'styled-components'
import { Button } from 'reactstrap'
import {
  authSelector,
  lobSelector,
  companySelector,
} from './../../../selectors'
import {
  lobAction,
  companyAction,
} from './../../../actions/'
import CustomModalMessage from '../../../components/modal-message'
import LOBForm from '../../../components/lob'

class CreateLOB extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lob_code: '',
      lob: '',
      company_id: '',
      edit: false,
      createModal: false,
      id: '',
      modalDelete: false,
      modalCancel: false,
      activeTab: '1',
      start_date: '',
      is_active: true,
    }
    this.handleInput = this.handleInput.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.deactivateLOB = this.deactivateLOB.bind(this)
    this.handleLOBLead = this.handleLOBLead.bind(this)
    this.createEmployeeList = this.createEmployeeList.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
  }

  componentDidMount() {
    this.props.listCompany(localStorage.getItem('access_token'))
  }

  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'lobGet')) {
      this.setState({
        lob_code: _.get(nextProps, 'lobGet.lob_code'),
        lob: _.get(nextProps, 'lobGet.name'),
        company_id: _.get(nextProps, 'lobGet.company_id'),
        start_date: _.get(nextProps, 'lobGet.start_date') ? _.get(nextProps, 'lobGet.start_date') : '',
        is_active: _.get(nextProps, 'lobGet.is_active'),
      })
      this.props.resetGetLOB()
    }
    if (_.get(nextProps, 'edit')) {
      if (_.get(nextProps, 'edit.edit')) {
        this.setState({ id: _.get(nextProps, 'edit.id'), edit: false })
        this.props.handleClickEdit(false, '')
        this.props.getLOB(_.get(nextProps, 'edit.id'), localStorage.getItem('access_token'))
        this.props.resetGetLOB()
      }
      this.setState({
        edit: false,
      })
    }
  }

  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleClickEdit() {
    this.setState({ edit: true })
  }
  handleDelete() {
    this.deactivateLOB()
    this.props.cancelDelete()
    this.props.handleSpan(false)
  }
  handleDiscard() {
    this.props.cancelDiscard()
    this.props.handleSpan(false)
  }
  deactivateLOB() {
    this.props.deactivateLOB(_.get(this.state, 'id'), localStorage.getItem('access_token'))
  }
  createEmployeeList(arr) {
    const object = _.get(this.props, 'employeeList')
    const temp = []
    if (object && arr) {
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < object.length; j++) {
          if (_.get(arr[i], 'id') === _.get(object[j], 'value')) {
            temp.push(object[j])
            break
          }
        }
      }
    }
    return temp
  }
  submitForm() {
    if (_.get(this.state, 'edit')) {
      
      this.props.editLOB(
        _.get(this.state, 'id'),
        {
          lob_code: this.state.lob_code,
          name: this.state.lob,
          company_id: this.state.company_id,
          start_date: new moment(this.state.start_date),
          is_active: this.state.is_active,
        },
        localStorage.getItem('access_token'))
    } else {
      this.props.createLOB(
        {
          name: this.state.lob,
          company_id: this.state.company_id,
        },
        localStorage.getItem('access_token'))
    }
  }
  handleLOBLead(e) {
    const temp = []
    e.map((lead) => {
      temp.push({ id: lead.value })
      return lead
    })
    return temp
  }

  render() {
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.props.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.edit ? this.submitForm : this.handleClickEdit }>{ this.state.edit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    return (
      <div>
        { _.get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.props.cancelDelete }
            show={ _.get(this.props, 'confirmType') === 'confirmDelete' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
        }
        { _.get(this.props, 'confirmType') === 'confirmDiscard' &&
        <CustomModalMessage
          hide={ this.props.cancelDiscard }
          show={ _.get(this.props, 'confirmType') === 'confirmDiscard' }
          type={ _.get(this.props, 'confirmStatus') }
          message={ _.get(this.props, 'confirmMessage') }
          button={ buttonDiscard }
        />
        }
        <LOBForm
          edit={ this.state.edit }
          list={ _.get(this.props, 'listCompanyData') }
          handleClickEdit={ this.handleClickEdit }
          lob_code={ this.state.lob_code }
          lob={ this.state.lob }
          company_id={ this.state.company_id }
          lob_leaders={ this.state.lob_leaders }
          start_date={ this.state.start_date }
          is_active={ this.state.is_active }
          employeeList={ _.get(this.props, 'employeeList') }
          button={ button }
          confrim={ _.get(this.props, 'confirm') }
          submitForm={ this.submitForm }
          handleSpan={ this.props.handleSpan }
          handleLOBLead={ (e) => this.setState({ lob_leaders: e }) }
          handleInput={ this.handleInput }
          cancelForm={ this.props.cancelForm }
          showDiscard={ this.state.edit ? this.props.showDiscard : () => this.props.handleSpan(false) }
        />
      </div>
    )
  }
}

CreateLOB.propTypes = {
  createLOB: PropTypes.func.isRequired,
  editLOB: PropTypes.func.isRequired,
  getLOB: PropTypes.func.isRequired,
  resetGetLOB: PropTypes.func.isRequired,
  listCompany: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  deactivateLOB: PropTypes.func.isRequired,
  cancelDelete: PropTypes.func.isRequired,
  cancelDiscard: PropTypes.func.isRequired,
  showDelete: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getUserData,
  lobCreate: lobSelector.getCreateLOBData,
  lobEdit: lobSelector.getEditLOBData,
  lobGet: lobSelector.getLOBData,
  lobDeactivate: lobSelector.getDeactivateLOBData,
  listCompanyData: companySelector.getListCompany,
})(state, props)

const mapDispatchToProps = dispatch => bindActionCreators({
  createLOB: lobAction.createLOB,
  resetCreateLOB: lobAction.resetCreateLOB,
  editLOB: lobAction.editLOB,
  resetEditLOB: lobAction.resetEditLOB,
  getLOB: lobAction.getLOBbyID,
  resetGetLOB: lobAction.resetGetLOB,
  listCompany: companyAction.getCompany,
  lobList: lobAction.getLOB,
  deactivateLOB: lobAction.deactivateLOB,
  resetDeactivateLOB: lobAction.resetDeactivateLOB,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CreateLOB)

const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/lob/edit/index.js